import { defineStore } from 'pinia'
import type { Ticket } from '@/interfaces/tickets'

export interface TicketFormDraft {
  type: Ticket['type']
  subject: string
  issue_type: string
  sub_area: string
  priority: Ticket['priority']
  message: string
}

function defaultDraft(): TicketFormDraft {
  return {
    type: 'Private',
    subject: '',
    issue_type: '',
    sub_area: '',
    priority: 'Medium',
    message: '',
  }
}

export const useTicketFormStore = defineStore('ticketForm', {
  state: () => ({
    showModal: false,
    isEditMode: false,
    editingTicketId: null as string | null,
    form: defaultDraft(),
  }),

  actions: {
    resetDraft() {
      this.form = defaultDraft()
    },

    openCreate() {
      // Keep existing draft when reopening create modal.
      if (this.isEditMode) {
        this.resetDraft()
      }
      this.isEditMode = false
      this.editingTicketId = null
      this.showModal = true
    },

    openEdit(ticket: Ticket) {
      this.isEditMode = true
      this.editingTicketId = ticket.id
      this.form.type = ticket.type ?? 'Private'
      this.form.subject = ticket.subject ?? ''
      this.form.issue_type = ticket.issue_type ?? ''
      this.form.sub_area = ticket.sub_area ?? ''
      this.form.priority = ticket.priority ?? 'Medium'
      this.form.message = ticket.message ?? ''
      this.showModal = true
    },

    closeModal() {
      this.showModal = false
    },

    clear() {
      this.showModal = false
      this.isEditMode = false
      this.editingTicketId = null
      this.resetDraft()
    },
  },
})
